<template lang="pug">
#bills
  v-banner.title-banner(min-height="88")
    .text-h4.font-weight-bold {{ this.$t('Menu.__Purchase') + ' : ' + this.$t('Menu.__Bill') }}
    template(v-slot:actions)
      v-btn.ml-6(rounded, color="primary", @click="$router.push({ name: 'BillNew' })") {{ $t('Bills.__AddBill') }}

  v-container
    v-tabs(v-model="tab")
      v-tab(:key="0")
        span {{ $t('Bills.__Bill') }}
      v-tab(:key="1")
        span {{ $t('Bills.__ReceivedInvoices') }}
    v-divider
    v-tabs-items(v-model="tab")
      v-tab-item.action-bar.mb-8(:key="0")
        v-row
          v-col(cols="12", md="3")
            VendorSelector(v-model="selectedVendor", :insert-tag="false")
            //- v-select(
            //-     v-model="selectedVendor",
            //-     solo,
            //-     dense,
            //-     clearable,
            //-     outlined,
            //-     hide-details,
            //-     return-object,
            //-     :items="vendors",
            //-     item-text="name",
            //-     item-value="id",
            //-     :placeholder="$t('Placeholder.__Vendor')"
            //- )
          v-col(cols="12", md="3")
            v-menu(
              v-model="rangeDateMenu",
              offset-y,
              :close-on-content-click="false",
              :nudge-right="40",
              transition="scale-transition",
              min-width="290px"
            )
              template(v-slot:activator="{ on }")
                v-text-field(
                  :value="dateRangeText",
                  clearable,
                  hide-details,
                  solo,
                  dense,
                  outlined,
                  readonly,
                  append-icon="event",
                  v-on="on",
                  :placeholder="$t('Placeholder.__DateRange')",
                  @click:clear="dates = []"
                )
              v-date-picker(
                v-model="dates",
                @input="rangeDateMenu = dates.length == 2 ? false : true",
                :locale="$store.getters['account/language']() == 'tw' ? 'zn-tw' : ''",
                range
              )
        Alert
        v-data-table.mb-6(
          :headers="headers",
          :items="bills",
          hide-default-footer,
          :options.sync="options",
          :loading="loading",
          :custom-sort="defaultDataSort"
        ) 
          template(v-slot:item.vendorName="{ item }")
            .vendor-name {{ item.vendor.name }}
          template(v-slot:item.status="{ item }")
            v-chip(dark, small, :color="getStatusColor(item.status)") {{ $t('Status.__' + item.status) }}
          template(v-slot:item.amount="{ item }")
            .unpaid-amount.text-subtitle-2 {{ getAmountWithCurrency(item.unpaid, currencyCode) }}
            .total-amount.text-caption.grey--text {{ $t('Bills.__Total') }} {{ getAmountWithCurrency(item.amount, currencyCode) }}
          template(v-slot:item.actions="{ item }")
            //- v-btn(text color="primary")  記錄付款資訊
            v-menu(bottom, left)
              template(v-slot:activator="{ on }")
                v-btn(icon, v-on="on")
                  v-icon(outlined, color="gray") keyboard_arrow_down
              v-list
                template(v-for="(menu, i) in actionItems")
                  v-list-item(:key="i", @click="menu.click(item)")
                    v-list-item-title {{ menu.title }}
                  v-divider(v-if="menu.divider")

        v-row.pagination-row
          v-col.d-flex.align-center.justify-start(cols="6")
            span.mr-2.d-md-block.d-none {{ $t('Table.__ItemsPerPage') }}
            span
              v-select.page-select(v-model="options.itemsPerPage", solo, dense, outlined, hide-details, :items="perPageItems")
          v-col.d-flex.justify-end(cols="6")
            v-pagination(v-model="options.page", :length="pageCount")
      v-tab-item.mb-8(:key="1")
        Alert
        v-data-table.mt-2.mb-6(
          :headers="invoiceHeaders",
          :items="receivedInvoices",
          hide-default-footer,
          :options.sync="invoiceOptions",
          :loading="loading"
        )
          template(v-slot:item.vendorName="{ item }")
            .vendor-name {{ item.vendor.name }}
          template(v-slot:item.actions="{ item }")
            v-menu(bottom, left)
              template(v-slot:activator="{ on }")
                v-btn(icon, v-on="on")
                  v-icon(outlined, color="gray") keyboard_arrow_down
              v-list
                template(v-for="(menu, i) in invoiceActionItems")
                  v-list-item(:key="i", @click="menu.click(item)")
                    v-list-item-title {{ menu.title }}
                  v-divider(v-if="menu.divider")
        v-row.pagination-row
          v-col.d-flex.align-center.justify-start(cols="6")
            span.mr-2.d-md-block.d-none {{ $t('Table.__ItemsPerPage') }}
            span
              v-select.page-select(
                v-model="invoiceOptions.itemsPerPage",
                solo,
                dense,
                outlined,
                hide-details,
                :items="perPageItems"
              )
          v-col.d-flex.justify-end(cols="6")
            v-pagination(v-model="invoiceOptions.page", :length="invoicePageCount")

    ConfirmDialog(
      v-model="deleteDialog",
      :title="$t('Bills.__DeleteBill')",
      :message="$t('Bills.__ConfirmDeleteBill')",
      :cancel-text="$t('ActionOption.__Cancel')",
      :confirm-text="$t('ActionOption.__Delete')",
      :confirm-action="deleteBill"
    )
    ConfirmDialog(
      v-model="deleteInvoiceDialog",
      :title="$t('Bills.__DeleteInvoiceToBill')",
      :message="$t('Bills.__ConfirmDeleteInvoiceToBill')",
      :cancel-text="$t('ActionOption.__Cancel')",
      :confirm-text="$t('ActionOption.__Delete')",
      :confirm-action="deleteInvoiceToBill"
    )
    RecordBillPaymentDialog(
      v-model="recordPaymentDialog",
      :invoice-id="selectBill.id",
      :amount="selectBill.unpaid",
      :subtitle="$t('Bills.__No') + ' #' + selectBill.number",
      :confirm-action="recordPaymentDone"
    )
</template>
<script>
import * as TimeHelper from "@/utils/timeHelper"
import RecordBillPaymentDialog from "@/components/dialogs/RecordBillPaymentDialog"
import * as currencyHelper from "@/utils/currencies"
import * as datatableHelper from "@/utils/datatableHelper.js"

export default {
  props: ["alert"],
  mixins: [currencyHelper.mixin, TimeHelper.mixin, datatableHelper.mixin],
  components: {
    RecordBillPaymentDialog
  },
  data() {
    return {
      perPageItems: [10, 25, 50],
      pageCount: 0,
      options: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
      loading: false,
      filters: {},

      //invoices
      invoicePageCount: 0,
      invoiceOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      },
      oading: false,

      tab: 0,
      recordPaymentDialog: false,
      selectBill: {},
      statusItems: [
        {
          text: this.$t("Status.__Unpaid"),
          color: "#505356",
          key: "Unpaid"
        },
        {
          text: this.$t("Status.__Partial"),
          color: "#b3e87f",
          key: "Partial"
        },
        {
          text: this.$t("Status.__Paid"),
          color: "#8cdc3c",
          key: "Paid"
        },
        {
          text: this.$t("Status.__Expired"),
          color: "#e6465a",
          key: "Expired"
        }
      ],
      actionItems: [
        {
          title: this.$t("Bills.__RecordPayment"),
          click: item => {
            this.recordPaymentDialog = true
            this.selectBill = item
          }
        },
        { title: this.$t("ActionOption.__Edit"), click: this.editItem },
        {
          title: this.$t("ActionOption.__Duplicate"),
          divider: true,
          click: this.duplicateItem
        },
        {
          title: this.$t("ActionOption.__Delete"),
          click: this.deleteItem
        }
      ],
      invoiceActionItems: [
        {
          title: this.$t("Bills.__AddBillForInvoice"),
          click: this.addBillForInvoice
        },
        {
          title: this.$t("ActionOption.__ExportPDF"),
          click: this.downloadPDF
        },
        { title: this.$t("ActionOption.__View"), click: this.viewItem },
        {
          title: this.$t("ActionOption.__Delete"),
          click: this.deleteInvoiceItem
        }
      ],
      deleteDialog: false,
      deleteInvoiceDialog: false,
      deleteId: null,
      selectedVendor: null,
      rangeDateMenu: false,
      dates: [],
      sortedDate: [],
      searchText: "",
      headers: [
        {
          text: this.$t("Bills.__Date"),
          align: "start",
          sortable: true,
          value: "issuedAt"
        },
        {
          text: this.$t("Bills.__Title"),
          align: "start",
          sortable: true,
          value: "name"
        },
        {
          text: this.$t("Bills.__No"),
          align: "start",
          sortable: true,
          value: "number"
        },
        {
          text: this.$t("Bills.__Vendor"),
          align: "start",
          sortable: true,
          value: "vendorName"
        },
        {
          text: this.$t("Bills.__Status"),
          align: "end",
          sortable: true,
          value: "status"
        },
        {
          text: this.$t("Bills.__AmountDue"),
          align: "end",
          sortable: true,
          value: "amount"
        },
        {
          text: "",
          align: "center",
          width: "200px",
          sortable: false,
          value: "actions"
        }
      ],
      invoiceHeaders: [
        {
          text: this.$t("EstimatesAndInvoices.__Title"),
          align: "start",
          sortable: true,
          value: "name"
        },
        {
          text: this.$t("EstimatesAndInvoices.__InvoiceDueOn"),
          align: "start",
          sortable: true,
          value: "expiredAt"
        },
        {
          text: this.$t("EstimatesAndInvoices.__No"),
          align: "start",
          sortable: true,
          value: "number"
        },
        {
          text: this.$t("Bills.__VendorName"),
          align: "start",
          sortable: true,
          value: "vendorName"
        },
        {
          text: this.$t("EstimatesAndInvoices.__Amount"),
          align: "start",
          sortable: true,
          value: "amount"
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],
      // filteredBills: [],
      bills: [],
      receivedInvoices: []
    }
  },
  watch: {
    dates(value) {
      if (this.dates.length > 0) {
        this.filters.from = this.dates[0]
        this.filters.to = this.dates.length == 2 ? this.dates[1] : this.dates[0]
      } else {
        delete this.filters["from"]
        delete this.filters["to"]
      }
      this.getBills()
    },
    selectedVendor(value) {
      if (this.selectedVendor) {
        this.filters.vendorId = this.selectedVendor.id
      } else {
        delete this.filters["vendorId"]
      }
      this.getBills()
    },
    options: {
      handler() {
        this.getBills()
      },
      deep: true
    },
    invoiceOptions: {
      handler() {
        this.getInvoices()
      },
      deep: true
    }
  },
  methods: {
    // filterBills() {
    //     this.filteredBills = this.bills
    //     this.filteredBills = this.filteredBills.filter(item => {
    //         return this.customer == null
    //             ? true
    //             : item.customer.id == this.customer.id
    //     })
    //     this.filteredBills = this.filteredBills.filter(item => {
    //         if (this.dates.length == 0) return true
    //         var dates = this.dates.slice().sort()
    //         var issuedAtTimestamp = this.date2unixtimestamp(item.issuedAt)
    //         var date1Timestamp = this.date2unixtimestamp(dates[0])
    //         var date2Timestamp = dates[1]
    //             ? this.date2unixtimestamp(dates[1])
    //             : 0
    //         return this.dates.length == 1
    //             ? issuedAtTimestamp == date1Timestamp
    //             : issuedAtTimestamp >= date1Timestamp &&
    //                   issuedAtTimestamp <= date2Timestamp
    //     })
    // },
    getBills() {
      var query = this.datatableOptionsToQuery(this.options)
      query = Object.assign({}, query, this.filters)
      this.loading = true
      // this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("bills/getBills", query)
        .then(
          function (response) {
            this.bills = response.data
            this.pageCount = response.paging.totalPages
            // this.$store.dispatch("global/stopLoading")
            this.loading = false
          }.bind(this)
        )
        .catch(
          function (error) {
            this.loading = false
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    getInvoices() {
      var query = this.datatableOptionsToQuery(this.invoiceOptions)
      this.loading = true
      this.$store
        .dispatch("invoices/getInvoiceToBills", query)
        .then(
          function (response) {
            this.receivedInvoices = response.data
            this.invoicePageCount = response.paging.totalPages
            this.loading = false
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function (error) {
            this.loading = false
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    editItem(item) {
      var id = item.id
      this.$router.push({
        name: "BillEdit",
        params: {
          id: id
        }
      })
    },
    duplicateItem(item) {
      this.$store
        .dispatch("bills/duplicateBill", item.id)
        .then(
          function (response) {
            this.$store.dispatch("global/stopLoading")
            this.getBills()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDuplicated"))
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    deleteItem(item) {
      this.deleteDialog = true
      this.deleteId = item.id
    },
    deleteBill() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("bills/deleteBill", this.deleteId)
        .then(
          function (response) {
            // this.getBills()
            this.options.page = 1
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDeleted"))
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.deleteDialog = false
    },
    recordPaymentDone() {
      this.getBills()
    },
    getStatusColor(status) {
      for (var item of this.statusItems) {
        if (item.key == status) {
          return item.color
        }
      }
    },
    addBillForInvoice(item) {
      this.$router.push({
        name: "BillForInvoice",
        params: {
          invoice: item
        }
      })
    },
    downloadPDF(item) {
      // this.$store.dispatch("global/startLoading")
      item.customer = this.$store.getters["bizes/biz"]()
      item.business = item.vendor
      // item.paid = 0
      this.$router.push({
        name: "InvoiceExport",
        params: {
          data: item,
          exportType: "download"
        }
      })
    },
    viewItem(item) {
      item.customer = this.$store.getters["bizes/biz"]()
      item.business = item.vendor
      // item.paid = 0
      this.$router.push({
        name: "ViewReceivedInvoice",
        params: {
          data: item
        }
      })
    },
    deleteInvoiceItem(item) {
      this.deleteInvoiceDialog = true
      this.deleteId = item.id
    },
    deleteInvoiceToBill() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("invoices/deleteInvoiceToBills", this.deleteId)
        .then(
          function (response) {
            this.getInvoices()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDeleted"))
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.deleteDialog = false
    }
  },
  computed: {
    dateRangeText() {
      return this.dates
        .slice()
        .sort()
        .join(" ~ ")
    },
    vendors() {
      return this.bills.map(function (bill) {
        return { id: bill.vendor.id, name: bill.vendor.name }
      })
    }
  },
  mounted() {
    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
  },
  created() {
    // this.getBills()
    // this.getInvoices()
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/formcontrol.scss";
</style>
